import { route } from 'frontend/inertia/routes'

export const settingsPath = {
  // mirrors edit_frontend_academy_partner_settings
  edit: route('/academy_partner/settings/edit'),
  // mirrors frontend_academy_partner_settings
  update: route('/academy_partner/settings'),
}
